import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { LetDirective } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';

import { FixRateCurrencyConverterPipe } from '@personal-area/global/accounts/utils';
import { MoneyPipe } from '@personal-area/global/billing/utils';
import { LoaderModule,RetryBlockScopedModule } from '@personal-area/global/http/ui';
import { LocalizedDateModule } from '@personal-area/global/i18n';
import { AlertModule } from '@personal-area/global/ui'
import { TogglerModule,TooltipCopyLinkComponent } from '@personal-area/global/ui';
import { IconComponent } from '@personal-area/global/ui';
import { IconSpriteModule } from '@personal-area/icon-sprite';

import { AccountViewerLeverageComponent } from '../account-viewer-leverage/account-viewer-leverage.component';
import { AccountViewerPasswordModule } from '../account-viewer-password/account-viewer-password.module';
import { AccountViewerSwapFreeComponent } from '../account-viewer-swap-free/account-viewer-swap-free.component';
import { AccountViewerPerformanceComponent } from './account-viewer-performance.component';

@NgModule({
  declarations: [AccountViewerPerformanceComponent],
  exports: [AccountViewerPerformanceComponent],
  imports: [
    CommonModule,
    AccountViewerLeverageComponent,
    AccountViewerPasswordModule,
    AccountViewerSwapFreeComponent,
    IconSpriteModule,
    TogglerModule,
    TooltipCopyLinkComponent,
    TranslateModule,
    LetDirective,
    LoaderModule,
    LocalizedDateModule,
    NgSelectModule,
    ReactiveFormsModule,
    AlertModule,
    RetryBlockScopedModule,
    FixRateCurrencyConverterPipe,
    IconComponent,
    MoneyPipe,
  ],
})
export class AccountViewerPerformanceModule {}
